import sv from './geo/sv';
import pa from './geo/pa';
import cr from './geo/cr';
import hn from './geo/hn';
import gt from './geo/gt';
import bz from './geo/bz';
import ni from './geo/ni';
import mx from './geo/mx';

var getLayers = function getLayers() {
  return {
    layers: [{
      type: 'layer',
      properties: {
        code: 'sv',
        name: 'El Salvador',
        shape: sv,
        style: {
          color: '#99df53',
          fillOpacity: 0.2,
          opacity: 0.6
        }
      }
    }, {
      type: 'layer',
      properties: {
        code: 'pa',
        name: 'Panama',
        shape: pa,
        style: {
          color: '#A0A644',
          fillOpacity: 0.2,
          opacity: 0.6
        }
      }
    }, {
      type: 'layer',
      properties: {
        code: 'cr',
        name: 'Costa Rica',
        shape: cr,
        style: {
          color: '#EB923D',
          fillOpacity: 0.2,
          opacity: 0.6
        }
      }
    }, {
      type: 'layer',
      properties: {
        code: 'hn',
        name: 'Honduras',
        shape: hn,
        style: {
          color: '#FB9A99',
          fillOpacity: 0.2,
          opacity: 0.6
        }
      }
    }, {
      type: 'layer',
      properties: {
        code: 'gt',
        name: 'Guatemala',
        shape: gt,
        style: {
          color: '#38E8B8',
          fillOpacity: 0.2,
          opacity: 0.6
        }
      }
    }, {
      type: 'layer',
      properties: {
        code: 'bz',
        name: 'Belize',
        shape: bz,
        style: {
          color: '#E0B24A',
          fillOpacity: 0.2,
          opacity: 0.6
        }
      }
    }, {
      type: 'layer',
      properties: {
        code: 'ni',
        name: 'Nicaragua',
        shape: ni,
        style: {
          color: '#3A9A52',
          fillOpacity: 0.2,
          weight: 5,
          opacity: 0.6
        }
      }
    }, {
      type: 'layer',
      properties: {
        code: 'mx',
        name: 'Mexico',
        shape: mx,
        style: {
          color: '#5486ea',
          fillOpacity: 0.2,
          opacity: 0.6
        }
      }
    }]
  };
};

export default getLayers;